String.prototype.decodeHTML = function () {
    return new DOMParser().parseFromString(this, 'text/html').documentElement.textContent;
}
